import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="max-w-xl mx-auto px-4 py-24 sm:py-32 text-center">
      <Seo title="Page not found — EI Battery Solutions" />
      <div className="font-display text-6xl font-bold text-ei-gold/70 tnum">404</div>
      <h1 className="mt-4 text-2xl font-bold text-ei-navy">We couldn't find that page</h1>
      <p className="mt-3 text-ei-graphite/80">The page may have moved or the link may be incorrect.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Link to="/" className="font-display text-sm font-bold bg-ei-navy text-ei-white px-6 py-3.5 rounded-sm hover:bg-ei-ink min-h-[44px] inline-flex items-center" data-testid="notfound-home">Back to home</Link>
        <Link to="/request-a-quote" className="font-display text-sm font-bold text-ei-navy border border-ei-navy/25 px-6 py-3.5 rounded-sm hover:border-ei-navy min-h-[44px] inline-flex items-center">Request a quote</Link>
      </div>
    </div>
  );
}
